// @flow

const IE_8 = 8;
const NOT_FOUND_IDX = -1;

export default function isIE(): false | number {
   const na = navigator.userAgent.toLowerCase();
   return na.indexOf('msie') === NOT_FOUND_IDX ? false : parseInt(na.split('msie')[1], 10);
}

export function isIE8() {
   return isIE() === IE_8;
}

export function isEdge() {
   return 'msLaunchUri' in window.navigator && !('documentMode' in document);
}

export function isIE11() {
   return  !!window.MSInputMethodContext && !!document.documentMode;
}
